import { useCategories } from '../lib/categories';
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Layout from "../components/Layout";
import DoorCard from "../components/DoorCard";
import { useLang } from "../lib/i18n";
import { api } from "../lib/api";



export default function Catalog() {
  const { t } = useLang();
  const CATS = ["all", ...useCategories()];
  const [doors, setDoors] = useState([]);
  const [category, setCategory] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/doors${category !== "all" ? `?category=${encodeURIComponent(category)}` : ""}`)
      .then((r) => setDoors(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <Layout>
      <section className="fd-container pt-12 md:pt-20 pb-8" data-testid="catalog-header">
        <p className="fd-label mb-4">— {t("nav.catalog")}</p>
        <h1 className="text-4xl md:text-6xl font-light tracking-tighter text-neutral-900">{t("catalog.title")}</h1>
        <p className="mt-4 text-neutral-500 max-w-md">{t("catalog.subtitle")}</p>
      </section>

      <section className="fd-container border-t border-neutral-200 py-6 sticky top-16 md:top-20 bg-white/80 backdrop-blur-md z-30" data-testid="catalog-filters">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="fd-label mr-3">{t("catalog.filter")}:</span>
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c}`}
              onClick={() => setCategory(c)}
              className={`px-4 py-2 text-xs uppercase tracking-widest rounded-sm border transition-colors duration-200 ${
                category === c
                  ? "bg-neutral-900 text-white border-neutral-900"
                  : "bg-white text-neutral-600 border-neutral-200 hover:border-neutral-900 hover:text-neutral-900"
              }`}
            >
              {t(`categories.${c}`)}
            </button>
          ))}
        </div>
      </section>

      <section className="fd-container py-12 md:py-16">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="catalog-loading">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-neutral-100 animate-pulse" />
            ))}
          </div>
        ) : doors.length === 0 ? (
          <div className="border border-dashed border-neutral-200 py-24 text-center text-sm text-neutral-400" data-testid="catalog-empty">
            {t("catalog.empty")}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="catalog-grid">
            {doors.map((d, i) => (
              <motion.div key={d.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.04 }}>
                <DoorCard door={d} />
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
